import base from "../../baseurl";
import token from "../../getTk";

const Create = async (name, disciplineTypeId, sportEventId) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("disciplines/create", {
      json: { name, disciplineTypeId, sportEventId },
      timeout: false,
    })
    .json();
  console.log(
    "LLamada para crear deporte en el evento",
    name,
    disciplineTypeId,
    sportEventId
  );
  return newS;
};

export default Create;
